// Scripts for the homepage demos, keyed by data-home-demo-script-value. Each
// gets the home-demo controller (`d`) and runs one loop; the controller resets
// the screen between loops. Markup lives in app/views/shared/home_demo/.

export default {
  // Inbox → approve → widget on Riley's site.
  async hero(d) {
    await d.wait(900)
    d.set("new", "on")
    d.find('[data-proof="bella"]').dataset.status = "pending"
    await d.wait(1100)
    await d.clickOn("approve-bella")
    d.find('[data-proof="bella"]').dataset.status = "approved"
    await d.wait(600)
    await d.clickOn("approve-pete")
    d.find('[data-proof="pete"]').dataset.status = "approved"
    await d.wait(1000)
    await d.clickOn("nav-widgets")
    d.findAll("[data-card]").forEach((card) => {
      card.hidden = d.find(`[data-proof="${card.dataset.card}"]`).dataset.status !== "approved"
    })
    d.findAll("[data-count]").forEach((el) => (el.textContent = d.findAll(".hh-grid [data-card]:not([hidden])").length))
    d.url("shosay.com/rileycartervo/widgets/homepage-love")
    d.nav("widgets")
    d.set("view", "widgets")
    await d.wait(1500)
    await d.move("card-bella", { dy: 20 })
    await d.wait(1400)
    await d.clickOn("layout-strip")
    d.set("layout", "strip")
    await d.wait(2000)
    await d.clickOn("copy-embed")
    d.set("copied", "on")
    await d.wait(1800)
  },

  // Capture form: pick video → record → name and photo → thanks → inbox.
  async collect(d) {
    await d.wait(900)
    await d.move("pick-audio")
    await d.wait(450)
    await d.clickOn("pick-video")
    d.set("step", "rec")
    await d.wait(400)
    const timer = d.find("[data-timer]")
    await Promise.all([
      (async () => {
        for (let s = 1; s <= 8; s++) {
          await d.wait(380)
          timer.textContent = `0:0${s}`
        }
      })(),
      d.type('[data-field="caption"]', "Great person to work with! Riley jumped into our audio drama…", { ms: 35 }),
    ])
    await d.clickOn("rec-stop")
    d.set("recorded", "on")
    await d.wait(700)
    await d.clickOn("rec-next")
    d.set("step", "contact")
    await d.wait(500)
    await d.clickOn("avatar")
    d.set("avatar", "on")
    await d.wait(400)
    await d.clickOn("name")
    await d.type('[data-field="name"]', "Bella Sapphire")
    await d.clickOn("role")
    await d.type('[data-field="role"]', "Voice actor, Sapphire Stones")
    await d.wait(300)
    await d.clickOn("submit")
    d.set("step", "thanks")
    await d.wait(1300)
    d.set("inbox", "on")
    await d.wait(2800)
  },

  // Label filter → tag a proof → survey responses → one response.
  async manage(d) {
    await d.wait(900)
    await d.clickOn("filter-podcasts")
    d.set("filter", "podcasts")
    await d.wait(1100)
    await d.clickOn("row-marcus")
    d.set("open", "marcus")
    await d.wait(1000)
    await d.clickOn("add-label")
    d.set("picking", "on")
    await d.type('[data-field="label"]', "home", { ms: 90 })
    await d.wait(300)
    await d.clickOn("pick-homepage")
    d.set("picking", "off")
    d.set("tagged", "on")
    await d.wait(1200)
    await d.clickOn("close")
    d.set("open", "")
    await d.wait(700)
    await d.clickOn("tab-survey")
    d.set("view", "survey")
    await d.wait(1300)
    await d.clickOn("resp-jenna")
    d.set("resp", "jenna")
    await d.wait(3400)
  },

  // Wall themes → live wall → two widgets on Riley's site.
  async share(d) {
    await d.wait(900)
    await d.clickOn("theme-bubbles")
    d.set("theme", "bubbles")
    await d.wait(1400)
    await d.clickOn("theme-chats")
    d.set("theme", "chats")
    await d.wait(1400)
    await d.clickOn("open-wall")
    d.set("view", "live")
    d.url("shosay.com/walls/rileycarter")
    await d.wait(6400)
    d.set("view", "widgets")
    d.nav("widgets")
    d.url("shosay.com/rileycartervo/widgets")
    await d.wait(800)
    await d.clickOn("w-marquee")
    d.set("widget", "marquee")
    await d.wait(2600)
    await d.clickOn("w-badge")
    d.set("widget", "badge")
    await d.wait(2600)
  },
}
